import { useSelector } from 'react-redux';
import { Project } from '@leverege/api-redux';
import { Config } from '@leverege/plugin';
export function getModelFromFactory(factory) {
  const vehicleTypes = useSelector(getVehicleUsageTypes);
  const vehicleTypeValues = vehicleTypes.map(usageType => usageType.value);
  return factory({
    vehicleTypes: vehicleTypeValues
  });
}
export function getVehicleUsageTypes(state) {
  const usageTypeEnumName = Config.get('VehicleSettings', 'usageTypeEnum', 'vehicleUsageType');
  const vehicleUsageTypeEnum = Project(window.Molten.getConfig('api/projectId')).enum(usageTypeEnumName).getEnum(state);
  return vehicleUsageTypeEnum?.values || [];
}